import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { getUniqueId } from '../../../functions/get-unique-id';
import { ExpandButtonComponent } from '../buttons/expand-button.component';

@Component({
  selector: 'app-expand-panel',
  imports: [CommonModule, ExpandButtonComponent],
  template: ` <div class="tw-flex">
    <div class="tw-min-w-0 md:tw-min-w-[44px]">
      @if (showButton) {
        <app-expand-button
          [expanded]="expanded"
          [parentId]="panelId"
          [label]="label"
          type="Right"
          (expand)="expanded = $event"
        />
      }
    </div>
    <div class="tw-grow tw-min-w-0 md:tw-min-w-auto">
      <div
        #container
        style="white-space: pre-line; overflow-y: hidden;"
        [style.max-height]="expanded ? '' : collapseHeight"
      >
        <ng-content></ng-content>
      </div>
    </div>
  </div>`,
  styles: ``,
})
export class ExpandPanelComponent implements AfterViewInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('container')
  container: ElementRef;

  @Input()
  expanded = false;

  @Input()
  collapseHeight = '200px';

  /** Subject for the expand button aria-label (without Expand/Collapse/panel). */
  @Input()
  label: string;

  protected panelId: string = getUniqueId('app-expand-panel');

  protected showButton = true;

  private resizeObserver: ResizeObserver;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      if (!this.expanded) {
        const prev = this.showButton;
        this.showButton =
          this.container.nativeElement.scrollHeight >
          this.container.nativeElement.clientHeight;

        if (prev != this.showButton) {
          this.cdr.markForCheck();
        }
      }
    });

    this.resizeObserver.observe(this.container.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
